var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cc-page"},[_c('Page',{staticClass:"page",attrs:{"show-total":"","total":_vm.total,"show-sizer":"","placement":_vm.placement,"page-size-opts":_vm.pageSizeOpts},on:{"on-change":_vm.onChange,"on-page-size-change":_vm.onPageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }